import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styles from './cross_fade.css';

export function CrossFade({
  children,
  transitionKey,
}: {
  children: React.ReactNode;
  transitionKey: string;
}) {
  const childRef = React.useMemo(
    () => React.createRef<HTMLDivElement>(),
    [transitionKey],
  );
  return (
    <TransitionGroup component={null} appear={true}>
      <CSSTransition
        key={transitionKey}
        classNames={styles}
        in={true}
        timeout={250}
      >
        <div className={styles.crossFade} ref={childRef}>
          {children}
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
}
